import React from 'react'
import Header from "../../components/header/index";
import InnerHeaderNewMethod from '../../components/comment/innerHeader/InnnerHeaderIcon'
import AddMethodContent from './addmethodcontent/addMethodContent';

import Footer from "../../components/footer";

const addnewmethod = () => {
  return (
    <div className="main">
    <Header />
    <InnerHeaderNewMethod title="Add a new payment method "/>
    <AddMethodContent />
    <Footer />
  </div>
  )
}

export default addnewmethod